import { USER_TYPE } from "@home-health-notify/domain";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import {
  getVisibleUserTypes,
  IOrganizationContext,
  OrganizationContext,
  useTranslation,
} from "hhn-commons";
import React, { useContext, useState } from "react";
import { useParams } from "react-router";
import TabPanel from "../common/tabs/TabPanel";
import Tabs from "../common/tabs/Tabs";
import ClinicianStaffDirectory from "./ClinicianStaffDirectory";
import PatientDirectory from "./PatientDirectory";
import PhysicianDirectory from "./PhysicianDirectory";
import {
  UserDirectoryContainer,
  UserDirectoryPanel,
  UserDirectoryPanelBox,
} from "./UserDirectory.style";

export function UserDirectory() {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "userDirectory" });
  const params = useParams();
  const { selectedOrgUser }: IOrganizationContext =
    useContext(OrganizationContext);
  const loggedInUserType =
    selectedOrgUser?.getOrganization()?.userProfile?.type ?? USER_TYPE.USER;

  const pathArr = params["*"]?.split("/") ?? [];
  let chatID: string | undefined = undefined;
  if (pathArr.length > 0 && pathArr[0]) chatID = pathArr[0];

  const shouldHideTabs = loggedInUserType === USER_TYPE.USER;

  const allTabs = [
    {
      index: 0,
      icon: <SupervisorAccountIcon />,
      label: `${tNs("userTypes.clinician")} / ${tNs("userTypes.staff")}`,
      userType: getVisibleUserTypes(loggedInUserType),
      dataTestId: "clinician-chats-tab",
    },
    {
      index: 1,
      icon: <MedicalServicesIcon />,
      label: tNs("userTypes.physician"),
      userType: [USER_TYPE.PHYSICIAN],
      dataTestId: "physician-chats-tab",
    },
    {
      index: 2,
      icon: <PersonAddAlt1Icon />,
      label: tNs("userTypes.patient"),
      userType: [USER_TYPE.PATIENT],
      dataTestId: "patient-chats-tab",
    },
  ];

  const getActiveTabValue = () => {
    return allTabs[0].index;
  };
  const [tabValue, setTabValue] = useState(getActiveTabValue());

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <UserDirectoryContainer data-testid="user-directory-container">
      {!shouldHideTabs && (
        <UserDirectoryPanel>
          <UserDirectoryPanelBox data-testid="user-directory-tabs">
            <Tabs tabs={allTabs} value={tabValue} onChange={handleChange} />
          </UserDirectoryPanelBox>
        </UserDirectoryPanel>
      )}

      <TabPanel value={tabValue} index={0} uniqueKey="chat-list">
        <ClinicianStaffDirectory chatID={chatID ?? ""} />
      </TabPanel>
      <TabPanel value={tabValue} index={1} uniqueKey="chat-list">
        <PhysicianDirectory
          chatID={chatID ?? ""}
          currentUserTypes={allTabs[1].userType}
        />
      </TabPanel>
      <TabPanel value={tabValue} index={2} uniqueKey="chat-list">
        <PatientDirectory
          chatID={chatID ?? ""}
          currentUserTypes={allTabs[2].userType}
        />
      </TabPanel>
    </UserDirectoryContainer>
  );
}
